import { render, staticRenderFns } from "./FiltroConfiguravel.vue?vue&type=template&id=6bcb498c&"
import script from "./FiltroConfiguravel.vue?vue&type=script&lang=js&"
export * from "./FiltroConfiguravel.vue?vue&type=script&lang=js&"
import style0 from "./FiltroConfiguravel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports